import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import { Dialog, Swiper } from 'antd-mobile-v5'
import React, { useEffect } from 'react'
import { getCookie } from '../../components/common/cookie'
import { isMainlandUser } from '../../utils/user'
import { getUserInfo } from '../../reducers/selectors'
import { useHasLogin } from '../../services/hooks'
import { useGetAdvItems } from '../../services/hooks/club'
import { getParameterByName, UClick } from '../../components/common/utils'
import { useHistory } from 'react-router-dom'
import styles from './Campaign.module.css'

const CampaignPage = () => {
  const { formatMessage } = useIntl()
  const { push } = useHistory()
  const { userInfo } = useSelector((state) => ({
    userInfo: getUserInfo(state),
  }))
  const isMainland = isMainlandUser(userInfo)
  const { data } = useHasLogin({
    manual: false,
  })
  const { data: advItems, runAsync: getAdvItems } = useGetAdvItems()
  const language = getCookie('language')
  const channel = getParameterByName('fromClub') ? 1 : 2

  useEffect(() => {
    if (userInfo && !advItems) {
      const is_hk = isMainland ? 0 : 1
      getAdvItems({ channel, is_hk })
    }
  }, [userInfo])

  useEffect(() => {
    UClick('campaign-page')
  }, [])

  const showWenjuan = () => {
    UClick('campaign-page-questionnaire')
    Dialog.show({
      title: formatMessage({ id: 'questionaire-title' }),
      content: formatMessage(
        { id: 'questionaire-message' },
        { course: formatMessage({ id: `questionaire-course-${data.wenJuan.type}` }) }
      ),
      showCloseButton: true,
      closeOnAction: true,
      actions: [
        [
          {
            key: 'cancel',
            text: formatMessage({ id: 'common-cancel' }),
          },
          {
            key: 'open',
            bold: true,
            text: formatMessage({ id: 'common-confirm' }),
            primary: true,
            onClick: () => {
              window.location.href = data.wenJuan.url
            },
          },
        ],
      ],
    })
  }

  const jumpToNextPage = (url, title) => {
    if (!url) return
    let type = ''
    if (title === '60 周年卡面') {
      type = 'anniversary'
    } else if (title === '水肺潜水快讯') {
      type = 'magzine'
    } else if (title === '日上免税满减券') {
      type = 'rishang'
    } else {
      type = ''
    }
    if (title) {
      UClick(`campaign-page-${type}`)
    }
    setTimeout(() => {
      if (url.indexOf('http') >= 0) {
        window.location.href = url
      } else {
        push(url)
      }
    }, 800)
  }

  if (!advItems) return null
  return (
    <>
      <Swiper indicator={() => null}>
        {advItems.carousel.map((item, index) => (
          <Swiper.Item key={index}>
            <img src={item.img} alt={item.title} className={styles.banner} />
          </Swiper.Item>
        ))}
      </Swiper>
      <div className={styles.advs}>
        {advItems.list.map((adv) => (
          <div className={styles['adv-item']} key={adv.title} onClick={() => jumpToNextPage(adv.jumpUrl, adv.title)}>
            <div className={styles.title}>{adv.title}</div>
            <div className={styles.desc}>{adv.desc}</div>
            <img src={adv.img} alt="img" className={styles.img} />
          </div>
        ))}
        {data && data.wenJuan && data.wenJuan.type && (
          <div className={styles['adv-item']} key="questionnaire" onClick={() => showWenjuan()}>
            <div className={styles.title}>问卷调查</div>
            <div className={styles.desc}>
              恭喜您完成了 PADI OW课程，请填写问卷，以便我们更好的为您服务，感谢您的支持！
            </div>
            <img
              src={require('../../assets/images/campaign/campaignPage/questionnaire.jpg')}
              alt="img"
              className={styles.img}
            />
          </div>
        )}
      </div>
    </>
  )
}

export default CampaignPage
